<template>
  <Modal id="materials-upload" #default="{ close }" @close="files = []">
    <div class="materials-upload-title">{{ $t('ModalMaterialsUpload.title') }}</div>
    <InputFile :file="lastFile" @change="addFiles" />
    <input
      class="dashed"
      type="text"
      :placeholder="$t('ModalMaterialsUpload.placeholder')"
      v-model="url"
      v-if="false"
    />

    <FileList :files="files" @remove="removeFile" @change="changeFile" />

    <div class="actions" v-if="files.length || url">
      <button class="primary" @click="upload" :disabled="pending.addLibraryResult">
        {{ pending.addLibraryResult ? 'Uploading...' : 'Upload' }}
      </button>
      <button @click="close">{{ $t('cancel') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import InputFile from '@/components/form/InputFile'
import FileList from '@/components/form/FileList'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'ModalMaterialsUpload',
  components: { FileList, InputFile, Modal },
  data() {
    return {
      files: [],
      url: '',
      additional: this.$route.params.additional !== undefined,
      folder: '',
    }
  },
  watch: {
    ['$route'](route) {
      this.additional = route.params.additional !== undefined
    },
  },
  computed: {
    lastFile() {
      return this.files[this.files.length-1]?.file;
    },
    ...mapState('library', ['pending']),
  },
  methods: {
    changeFile({ index, file }) {
      this.$set(this.files, index, file);
    },
    addFiles(files) {
      for (let file of files) {
        this.files.push({
          name: file.name,
          file,
          event: null,
        })
      }
    },
    removeFile(i) {
      this.files.splice(i, 1)
    },
    upload() {
      Promise.all(
        this.files.map(({ file, name, folder }) => {
          const data = new FormData()
          data.append('type', 'mfc')
          data.append('is_additional', this.additional ? 1 : 0)
          data.append('name', name)
          data.append('folder[]', folder)
          data.append('upload', file)
          if (this.folder) data.append('folder', this.file)
          return this.addLibrary({ data })
        })
      ).then(() => {
        this.closeModal()
        return this.getLibrary().then(() => {
          this.mfcProcessing()
        })
      })
    },
    ...mapMutations(['closeModal']),
    ...mapActions('library', ['addLibrary', 'getLibrary', 'mfcProcessing']),
  },
}
</script>

<style lang="scss">
#modal-materials-upload {
  .content {
    width: 440px;
  }

  .materials-upload-title {
    margin-bottom: 32px;

    font-weight: 700;
    font-size: 15.8824px;
    line-height: 131.9%;
    text-align: center;
    color: #353535;
  }

  input {
    margin-bottom: 7px;
  }

  label {
    width: 100%;
    margin-top: 12px;

    span {
      display: block;
      font-size: 15px;
      margin-bottom: 2px;
    }
  }

  select {
    height: 40px;
  }
}
</style>
